import React from 'react';

const Header = () => {
    return (
        <div className='container mx-auto'>
            <div className="text-center">
                <h3 className='text-xl font-extrabold text-gray-500 uppercase font-poppins'>Service</h3>
                <h2 className="text-3xl font-extrabold text-primary uppercase font-poppins">What i do</h2>
                <div className="flex justify-center rounded-full">
                    <hr className='w-48 h-2 rounded-full bg-[#BCD3FA]' />
                </div>
            </div>
        </div>
    );
};

export default Header;